import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import { pdfColors } from "../colors";
import { EnvironmentalData } from "@/services/environmentalDataService";
import { PDFColors } from "../types";

export const addDeforestationSection = (
  doc: jsPDF,
  data: EnvironmentalData,
  startY: number,
  colors: PDFColors,
): void => {
  let currentY = startY;

  // Rule 1: H1 Style (Bold, Uppercase)
  doc.setFont("helvetica", "bold");
  doc.setFontSize(16);
  doc.setTextColor(colors.primary[0], colors.primary[1], colors.primary[2]);
  doc.text("DEFORESTATION", 14, currentY);
  currentY += 10;

  // Rule 3: Key Indicators Block (Visually isolated shaded container)
  autoTable(doc, {
    startY: currentY,
    body: [
      [
        { content: "Annual Rate:", styles: { fontStyle: "bold" } },
        `${data.deforestation.ratePerYear}%`,
        { content: "Total Area Lost:", styles: { fontStyle: "bold" } },
        `${data.deforestation.totalLost.toLocaleString()} km²`,
      ],
    ],
    theme: "grid",
    styles: {
      fontSize: 11,
      cellPadding: 5,
      fillColor: [245, 247, 249] as [number, number, number],
    },
    margin: { left: 14, right: 14 },
  });

  currentY = (doc as any).lastAutoTable.finalY + 12;

  // Rule 2: H2 (Metric labels)
  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.setTextColor(colors.text[0], colors.text[1], colors.text[2]);
  doc.text("Primary Causes", 14, currentY);
  currentY += 8;

  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  data.deforestation.primaryCauses.forEach((cause, idx) => {
    doc.text(`• ${cause}`, 20, currentY);
    currentY += 6;
  });

  currentY += 6;

  // Rule 4: Historical trend table
  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("Historical Trend Data", 14, currentY);
  currentY += 6;

  autoTable(doc, {
    head: [["Year", "Deforestation (km²)"]],
    body: data.deforestation.yearlyData.map((item) => [
      item.year.toString(),
      item.value.toLocaleString(),
    ]),
    startY: currentY,
    theme: "striped",
    headStyles: {
      fillColor: colors.primary,
      textColor: [255, 255, 255] as [number, number, number],
    },
    styles: { fontSize: 10 },
    margin: { left: 14, right: 14 },
  });
};
